import AssessmentsWebsiteProcess from "./assessments/assessmentsWebsiteProcess";

/**
 * Public course page controller: wires assessment actions and popup cleanup.
 */
export default class CourseWebsiteProcessMain {
    constructor() {
        this.assessmentProcess = new AssessmentsWebsiteProcess();
        this.initEventListeners();
    }

    initEventListeners() {
        window.addEventListener("click", this.handleClick);
        document.addEventListener("vsPopupAfterClose", this.handlePopupClose);
    }

    handleClick = (event) => {
        const sendButton = event.target.closest(".assessment-send");
        const idkButton = event.target.closest(".assessment-idk");
        const tryAgainButton = event.target.closest(".try-again-post");
        const takeLessonButton = event.target.closest(".assessment-take-lesson");

        if (sendButton) {
            event.preventDefault();
            this.assessmentProcess.checkResult();
            return;
        }

        if (idkButton) {
            event.preventDefault();
            this.assessmentProcess.iDontKnowHandle();
            return;
        }

        if (tryAgainButton) {
            event.preventDefault();
            this.assessmentProcess.tryAgainHandle();
            return;
        }

        if (takeLessonButton) {
            event.preventDefault();
            this.assessmentProcess.openTutorialFromPopup();
            return;
        }
    };

    handlePopupClose = (event) => {
        if (event.detail.popup.id !== "take-assessment-popup") {
            return;
        }
        const popupElement = document.querySelector("#take-assessment-popup");
        if (!popupElement) {
            return;
        }

        const bodyEl = popupElement.querySelector(".cg-popup__body") || popupElement.querySelector(".popup-body");
        const resultEl = popupElement.querySelector(".cg-popup__result") || popupElement.querySelector(".assessment-result");

        // Reset state so the next assessment starts clean.
        setTimeout(() => {
            if (bodyEl) bodyEl.innerHTML = "";
            if (resultEl) resultEl.innerHTML = "";
            popupElement.classList.remove("is-correct", "is-incorrect");
            popupElement.querySelectorAll("input").forEach((input) => {
                input.disabled = false;
            });
        }, 200);
    };

    /**
     * Adapter used by the inline website handler (window.publicAssessmentRunner.run).
     */
    getPublicAssessmentRunner() {
        return {
            run: (config = {}) => {
                const { stage, topicId, assessmentType, parentAssessId } = config;
                if (!topicId || !assessmentType) {
                    console.error("Invalid public assessment config", config);
                    return;
                }
                this.assessmentProcess.run({
                    topicId: parseInt(topicId, 10),
                    assessmentType: parseInt(assessmentType, 10),
                    parentAssessId: parentAssessId ? parseInt(parentAssessId, 10) : null,
                    stage: stage || "pre"
                });
            }
        };
    }
}
